import { useEffect } from "react";

const ParkingSpotMarker = ({ spot, map, maps }) => {
  useEffect(() => {
    if (!map || !maps || !spot) {
      return;
    }

    const marker = new maps.Marker({
      position: {
        lat: spot.latitude,
        lng: spot.longitude,
      },
      map,
      title: "Parking Spot",
      label: {
        text: "P",
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: "700",
      },
      icon: {
        path: maps.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: "#145C9E",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
      },
    });

    return () => marker.setMap(null);
  }, [map, maps, spot]);

  return null;
};

export default ParkingSpotMarker;
